// Generate a random string.
// Mainly used for generating unique ids

export const randomStr = (str = '') => {
    if (str.length) {
      return `${str.replace(/ +/g, '-')}-${Math.random().toString(36).substr(2, 10)}`.toLowerCase();
    }
  
    return Math.random().toString(36).substr(2, 10);
  };
  
  export default randomStr;
  


// WEBPACK FOOTER //
// ./src/utils/randomStr.js